import { object, string } from 'yup';
import HttpStatus from 'http-status-codes';

export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    phoneNumber: 'Phone number should be in proper format'
  }
};

export default object().shape({
  firstName: string().required('Please enter your first name'),
  lastName: string().required('Please enter your last name'),
  phoneNumber: string()
    .required('Please enter your phone number')
    .matches(/\d{3}-\d{3}-\d{4}$/, 'Please use xxx-xxx-xxxx format')
});
